// removed by extract-text-webpack-plugin
module.exports = {"Label":"Input__Label__2mWLX","Input":"Input__Input__2xTOK","Star":"Input__Star__35soi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/Input/Input.css
// module id = 150
// module chunks = 0